const normalizeText = (value: any) => `${value ?? ""}`.trim();

export const normalizePlateNumber = (value: any) =>
  normalizeText(value).replace(/\s+/g, "");

export const getChangedValue = (value: any) => value?.target?.value ?? value;

const normalizeFuelType = (value: any) =>
  normalizeText(value).replace(/\s+/g, "");

const isChecked = (value: any) =>
  Array.isArray(value) ? value.length > 0 : !!value;

/**
 * 按佣金结算开发文档的页面自动关联规则计算结算方式。
 */
export const getAutoSettlementType = (values: any) => {
  const fuelType = normalizeFuelType(values?.fuelType);
  const installmentType = normalizeText(values?.installmentType);
  const partner = normalizeText(values?.partner);
  const department = normalizeText(values?.department);
  const plateNumber = normalizePlateNumber(values?.plateNumber);

  if (!fuelType || !["分期", "不分期"].includes(installmentType)) {
    return undefined;
  }

  const isInstallment = installmentType === "分期";
  const isNewEnergy = fuelType === "新能源/电";
  const hasThreeElectricity = isChecked(values?.threeElectricityFlag);
  const isFuTongHui = partner === "付同辉";
  const isTianjinJinPlate =
    department === "天津营业部" && plateNumber.startsWith("津");

  if (isTianjinJinPlate) {
    if (isNewEnergy) {
      if (hasThreeElectricity) {
        if (isInstallment) {
          return isFuTongHui
            ? "25.10付同辉新能源含三电-分期结算"
            : "25.10新规新能源含三电-分期结算";
        }
        return isFuTongHui
          ? "25.10付同辉新能源含三电-整笔结算"
          : "25.10新规新能源含三电-整笔结算";
      }

      if (isInstallment) {
        return isFuTongHui
          ? "25.7付同辉-常规分期结算"
          : "26.7天津-分期结算";
      }
      return isFuTongHui
        ? "25.7付同辉-常规整笔结算"
        : "26.7天津-整笔结算";
    }

    return isInstallment ? "26.7天津-分期结算" : "26.7天津-整笔结算";
  }

  if (!isNewEnergy) {
    if (isInstallment) {
      return isFuTongHui
        ? "25.10付同辉常规-分期结算"
        : "26.7常规-分期结算";
    }
    return isFuTongHui
      ? "25.10付同辉常规-整笔结算"
      : "26.7常规-整笔结算";
  }

  if (hasThreeElectricity) {
    if (isInstallment) {
      return isFuTongHui
        ? "付同辉-新规新能源含三电分期结算"
        : "25.10新规新能源含三电-分期结算";
    }
    return isFuTongHui
      ? "付同辉-新规新能源含三电整笔结算"
      : "25.10新规新能源含三电-整笔结算";
  }

  if (isInstallment) {
    return isFuTongHui
      ? "25.7付同辉-常规分期结算"
      : "26.7常规-分期结算";
  }
  return isFuTongHui
    ? "25.7付同辉-常规整笔结算"
    : "26.7常规-整笔结算";
};
